import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  icons: {
    iconfont: "mdi",
  },
  theme: {
    themes: {
      light: {
        primary: "#6578b4",
        secondary: "#3145d2",
        accent: "#384263",
        error: "#b71c1c",
        danger: "#ff6b6b",
        warning: "#e9c46a",
        success: "#2a9d8f",
        grey: "#f8f9fa",
      },
      // dark: {
      //   primary: colors.blue.lighten3,
      // },
    },
  },
});
